import { AmplitudeEventProperty, logAmplitudeEvent } from 'chairisher/util/analytics';

/**
 * Tracks the visibility of content that can be shown or hidden
 * @param {boolean} isVisible - indicates if the content is visible
 * @param {string} position - the position on the screen
 * @param {Object=} additionalEventProperties - Optional collection of additional event properties to track
 */
export default function trackContentVisibility(isVisible, position, additionalEventProperties = {}) {
    logAmplitudeEvent(`content - ${isVisible ? 'show' : 'hide'}`, {
        [AmplitudeEventProperty.POSITION]: position,
        ...additionalEventProperties,
    });
}
